// 获取圈子列表
export const GetMoments = ({ current, pageSize, momentType }) => {
  return {
    url: '/api/moment/page/v1',
    method: 'post',
    data: {
      current,
      pageSize,
      momentType,
    },
  };
};

/**
 * @description 获取所有圈子
 */
export const GetAllMoments = () => {
  return {
    url: '/api/moment/v1',
    method: 'get',
  };
};

// 获取圈子中间页信息
export const GetMomentIntro = momentId => {
  return {
    url: `/api/moment/intro/${momentId}/v1`,
    method: 'get',
  };
};
// 用户加入圈子
export const UserJoinMoment = momentId => {
  return {
    url: `/api/momentUser/v1`,
    method: 'post',
    data: {
      momentId,
    },
  };
};
// 获取圈子详情
export const GetMomentDetail = momentId => {
  return {
    url: `/api/moment/${momentId}/v1`,
    method: 'get',
  };
};

// 获取嘉宾圈主列表
export const GetMomentGuests = (momentId, page = 1) => {
  return {
    url: `/api/momentUser/askQuestionUser/v1`,
    method: 'post',
    data: {
      momentId,
      page,
      pageSize: 5,
    },
  };
};

// 获取圈子标签列表
export const GetMomentTags = momentId => {
  return {
    url: `/api/moment/tag/${momentId}/v1`,
    method: 'get',
  };
};

// 获取圈子内容列表
export const GetMomentContent = ({ momentId, page, count, tagId }) => {
  return {
    url: `/api/moment/${momentId}/content/v1`,
    method: 'get',
    params: {
      page,
      count,
      tagId,
    },
  };
};

// 获取 管理 or 创建的圈子
export const GetAdminMoments = () => {
  return {
    url: `/api/moment/administrative/v1`,
    method: 'get',
  };
};

// 置顶圈子动态
export const PutMomentContentStickTop = ({ momentId, dynamicId, top }) => {
  return {
    url: `/api/moment/${momentId}/content/top/v1`,
    method: 'put',
    data: {
      dynamicId,
      top,
      momentId,
    },
  };
};

// 设置精华
export const PutMomentContentEssence = ({ momentId, dynamicId, essence }) => {
  return {
    url: `/api/moment/${momentId}/content/essence/v1`,
    method: 'put',
    data: {
      dynamicId,
      essence,
      momentId,
    },
  };
};

// 获取搜索结果
export const DoMomentResearch = ({ momentId, type, keyword, page }) => {
  return {
    url: `/api/search/moment/${momentId}/${type}/v1`,
    method: 'get',
    params: {
      keyword,
      page,
    },
  };
};

// 获取可分享的圈子列表
export const GetShareAbleMoments = () => {
  return {
    url: '/api/moment/shareable/v1',
    method: 'get',
  };
};

// 获取可以分享的圈子标签
export const GetAvailableTags = momentId => {
  return {
    url: `/api/moment/tag/getCanSendDynamicTag/${momentId}/v1`,
    method: 'get',
  };
};

// 上传文件
export const UploadFile = (formData, onUploadProgress) => {
  return {
    url: `/api/file/upload/v1`,
    method: 'post',
    data: formData,
    timeout: 1000 * 120,
    onUploadProgress,
  };
};

// 忽略问答
export const IgnoreQuestion = dynamicId => {
  return {
    url: `/api/moment/dynamic/ignore/v1`,
    method: 'put',
    data: {
      dynamicId,
    },
  };
};

/**
 * @description 检查内容是否包含敏感词
 * @param { object } data 请求参数
 */
export const reviewCheckSensitive = data => {
  return {
    url: '/api/review/check-sensitive/v1',
    method: 'put',
    data,
  };
};

/**
 * @description 审核自发的动态，评论
 * @param { object } data 请求参数
 */
export const reviewPost = data => {
  return {
    url: '/api/review/v1',
    method: 'put',
    data,
  };
};

/**
 * @description 获取圈子动态汇总需要展示的标签集合
 */
export const getQaTabList = () => {
  return {
    url: '/api/moment/dynamic/summary/show-tags',
    method: 'get',
  };
};

/**
 * @description 获取圈子动态汇总列表
 * @param { object } params 请求参数
 */
export const getQaList = params => {
  return {
    url: '/api/moment/dynamic/summary',
    method: 'get',
    params,
  };
};

/**
 * 问答动态轮播
 */
export const GetCarousel = () => {
  return {
    url: '/api/moment/dynamic/carousel',
    method: 'get',
  };
};

/**
 * @description 忽略提问
 * @param { number } dynamicId 动态id
 */
export const putIgnoreById = dynamicId => {
  return {
    url: `/api/moment/dynamic/ignore/v1`,
    method: 'put',
    data: {
      dynamicId,
    },
  };
};
